import { Ref, useImperativeHandle } from 'react';
import { useDraftValue } from '../../hooks/useDraftValue';
import DataTableSearchField from './DataTableSearchField';

export interface IDataTableGlobalSearchHandle {
    /** Текст поиска, заданный таблицей (сброс фильтров, `controlRef.setGlobalFilter`): заменяет набранное. */
    set: (text: string) => void;
}

interface IDataTableGlobalSearchProps {
    ref?: Ref<IDataTableGlobalSearchHandle>;
    /** Применённый поиск таблицы */
    value: string;
    /** Набранное после паузы: таблица применяет поиск */
    onApply: (text: string) => void;
}

/** Пауза ввода перед применением поиска (фильтрация клиентская, но и ей незачем каждый символ), мс */
const APPLY_DELAY = 300;

/**
 * Поле глобального поиска туллбара. Набираемый текст — своё состояние поля: до паузы ввода перерисовывается только поле,
 * а не таблица со всеми строками; наверх уходит итог. Поле убрали из туллбара до паузы — набранное применяется, как
 * применилось бы после неё. Применённое набранное повторно не уходит: `resetPageIndex()` из отложенного прогона
 * сбрасывал страницу, открытую программно (показ добавленной строки на последней странице).
 */
const DataTableGlobalSearch = ({ ref, value, onApply }: IDataTableGlobalSearchProps) => {
    const { draft, change, commit, replace } = useDraftValue(value, onApply, APPLY_DELAY, { flushOnUnmount: true });
    useImperativeHandle(ref, () => ({ set: replace }), [replace]);
    return (
        <DataTableSearchField
            value={draft}
            onChange={change}
            // очистка применяет пустой поиск сразу; неотправленный набор при пустом применённом просто отменяется
            onClear={() => commit('')}
            label="Поиск по таблице"
            placeholder="Поиск"
        />
    );
};

export default DataTableGlobalSearch;
